import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errorMessage } from "../../lib/api";
import { useLang } from "../../lib/i18n";
import { GROUP_LABELS, groupFields } from "../../lib/fieldMeta";
import { ProfileFieldInput } from "../../components/ProfileFieldInput";

export const ProfileForm = ({ employee, fields, canEdit, onSaved }) => {
  const { t, lang } = useLang();
  const [form, setForm] = useState({});
  const [saving, setSaving] = useState(false);
  const enabled = fields.filter((f) => f.enabled);
  const editable = (f) => canEdit && f.editable_by === "employee";
  useEffect(() => { setForm({ ...(employee.profile || {}) }); }, [employee]);

  const submit = async (e) => {
    e.preventDefault();
    setSaving(true);
    const profile = Object.fromEntries(enabled.filter(editable).map((f) => [f.key, form[f.key] || ""]));
    try {
      const { data } = await api.patch("/me/card", { profile });
      onSaved(data);
      toast.success(t("saved"));
    } catch (err) {
      toast.error(errorMessage(err));
    } finally {
      setSaving(false);
    }
  };

  return (
    <form onSubmit={submit} className="space-y-6 rounded-3xl border border-slate-200/80 bg-white p-5 sm:p-6" data-testid="card-edit-form">
      {groupFields(enabled).map(([group, list]) => (
        <fieldset key={group} data-testid={`card-edit-group-${group}`}>
          <legend className="mb-3 font-display text-base font-bold text-slate-900">{GROUP_LABELS[group][lang]}</legend>
          <div className="grid gap-4 sm:grid-cols-2">
            {list.map((f) => (
              <ProfileFieldInput key={f.key} field={f} value={form[f.key]} lang={lang} testPrefix="card-edit"
                readOnly={!editable(f)} onChange={(k, v) => setForm((s) => ({ ...s, [k]: v }))} />
            ))}
          </div>
        </fieldset>
      ))}
      {canEdit && (
        <button type="submit" disabled={saving} data-testid="card-edit-save"
          className="btn-press min-h-[52px] w-full rounded-2xl bg-slate-900 px-6 font-semibold text-white hover:bg-black disabled:opacity-60 sm:w-auto">
          {saving ? "…" : t("save_changes")}
        </button>
      )}
    </form>
  );
};
